module.exports = __webpack_public_path__ + "img/300g.34493da2.png";